import type { TRuleWithTheme } from '@/styles/theme';

export const container: TRuleWithTheme = ({ theme }) => ({
    display: 'flex',
    alignItems: 'center',

    gap: '1.25rem',
});

export const remainingTime: TRuleWithTheme = ({ theme }) => ({
    position: 'relative',
    top: -1,

    fontSize: '0.75rem',
    fontWeight: 600,
    lineHeight: 'normal',

    color: theme.colors.accentTertiary,
});

export const countdownContainer: TRuleWithTheme = () => ({
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
});
